<aside class="col-md-12 mb-0 h-100-margin px-0 px-sm-4">
  <div id="mainListPreBill" class="container-list h-100-margin">

    <div class="pre-bill-header d-flex align-items-center justify-content-between flex-wrap w-100">
      <mat-tab-group [selectedIndex]="0" (selectedIndexChange)="onSelectTab($event)" class="pre-bill-tabs">
        <mat-tab *ngFor="let tab of tabs" [label]="tab.label"></mat-tab>
      </mat-tab-group>
      <!-- La empresa acota el listado y la prefactura que se genere: va junto al botón, no entre los filtros. -->
      <div class="pre-bill-header__actions">
        <app-transport-company-context class="pre-bill-header__transport-company"
          [initialNit]="initialTransportCompanyId" size="field" (companyChange)="onTransportCompanyChange($event)">
        </app-transport-company-context>
        <button mat-raised-button color="primary" (click)="openPreBillForm('create')"
          class="bg-color-primary button-width-auto text-bold admin-users-list__actions--button pre-bill-header__generate">
          <i class="fas fa-plus-circle mr-2"></i>
          <span>Generar prefactura</span>
        </button>
      </div>
    </div>

    <div class="pre-bill-filters">
      <mat-form-field appearance="outline" class="pre-bill-consecutive-filter">
        <mat-label>N° Prefactura</mat-label>
        <input matInput type="text" onlyNumbersInt [formControl]="consecutiveControl"
          placeholder="Buscar por N° Prefactura" (keydown.enter)="$event.preventDefault(); searchByConsecutive()">
        <i matSuffix class="fas fa-search fa-lg cursor-pointer color-primary" matTooltip="Buscar"
          (click)="searchByConsecutive()"></i>
      </mat-form-field>

      <app-select-company class="pre-bill-company-filter"
        [options]="{ title: 'Cliente', appearance: 'outline', showXMark: true, optionAll: true }"
        [inputFormControl]="companyControl">
      </app-select-company>

      <mat-form-field *ngIf="activeState === 'Created' && prebillRequiresValidation" appearance="outline"
        class="pre-bill-validated-filter">
        <mat-label>Estado de validación</mat-label>
        <mat-select [formControl]="validatedControl" (selectionChange)="refreshList()">
          <mat-option value="all">Todos</mat-option>
          <mat-option [value]="true">Validado</mat-option>
          <mat-option [value]="false">No validado</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <ng-container *ngIf="listLoading; else preBillContent">
      <app-skeleton-loader variant="cargo-list" [rows]="5"></app-skeleton-loader>
    </ng-container>

    <ng-template #preBillContent>
      <div *ngIf="paginationList.getList().length" class="container-list-body" infinite-scroll
        [infiniteScrollDistance]="paginationList.getScrollDistance()"
        [infiniteScrollThrottle]="paginationList.getThrottle()" [scrollWindow]="false" (scrolled)="onScrollDown()">

        <div class="table-responsive pre-bill-table-wrapper">
          <table class="pre-bill-table">
            <thead>
              <tr>
                <th class="col-expand"></th>
                <th>N°</th>
                <th>Fecha de creación</th>
                <th>Creador</th>
                <th>Cliente</th>
                <th *ngIf="activeState === 'Created' && prebillRequiresValidation">Validación</th>
                <th>No. servicios</th>
                <th>Total</th>
                <th class="col-actions text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let preBill of paginationList.getList(); trackBy: trackByPreBill">
                <tr class="pre-bill-row" [class.is-expanded]="isExpanded(preBill)"
                  [class.is-disabled]="!canExpand(preBill)" matTooltip="Esta prefactura no tiene servicios asociados"
                  [matTooltipDisabled]="canExpand(preBill)" (click)="toggleExpand(preBill)">
                  <td class="col-expand">
                    <i class="fas pre-bill-expand-icon"
                      [ngClass]="isExpanded(preBill) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                  </td>
                  <td class="text-bold">{{ preBill?.consecutive || '-' }}</td>
                  <td>{{ preBill?.createdBy?.date ? (preBill.createdBy.date | dateFormat: 'date-time-full-24') : '-' }}
                  </td>
                  <td>{{ preBill?.createdBy?.userName || '-' }}{{preBill?.createdBy?.userId ? ' (' +
                    preBill?.createdBy?.userId + ')' : ''}}</td>
                  <td>{{ preBill?.companyId ? (preBill.companyId | companyName) : '-' }}</td>
                  <td *ngIf="activeState === 'Created' && prebillRequiresValidation">
                    <span class="state-badge"
                      [ngClass]="preBill?.validated ? 'state-validated' : 'state-not-validated'">
                      {{ preBill?.validated ? 'Validado' : 'No validado' }}
                    </span>
                  </td>
                  <td>{{ getCargosCount(preBill) }}</td>
                  <td>{{ preBill?.total ? (preBill.total | currency:'COP':'code') : '-' }}</td>
                  <td class="col-actions text-center" (click)="$event.stopPropagation()">
                    <button type="button" class="pre-bill-action-btn" [matMenuTriggerFor]="preBillActionsMenu"
                      matTooltip="Acciones" (click)="$event.stopPropagation()">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <mat-menu #preBillActionsMenu="matMenu">
                      <button mat-menu-item (click)="onViewPreBillHistory(preBill)">
                        <i class="fas fa-history mr-2"></i>
                        <span>Ver histórico de movimientos</span>
                      </button>
                      <button mat-menu-item *ngIf="canShowEditAction()"
                        [attr.aria-disabled]="!!getEditDisabledReason(preBill)"
                        [style.opacity]="getEditDisabledReason(preBill) ? '0.38' : '1'"
                        [style.cursor]="getEditDisabledReason(preBill) ? 'not-allowed' : 'pointer'"
                        [matTooltip]="getEditDisabledReason(preBill)"
                        [matTooltipDisabled]="!getEditDisabledReason(preBill)" matTooltipClass="tooltip__alert"
                        (click)="onEditPreBill(preBill)">
                        <i class="fas fa-edit mr-2"></i>
                        <span>Editar prefactura</span>
                      </button>
                      <button mat-menu-item
                        *ngIf="prebillRequiresValidation && !preBill?.validated && activeState === 'Created'"
                        (click)="onValidatePreBill(preBill, true)">
                        <i class="fas fa-check-circle mr-2"></i>
                        <span>Validar prefactura</span>
                      </button>
                      <button mat-menu-item
                        *ngIf="prebillRequiresValidation && preBill?.validated && activeState === 'Created'"
                        (click)="onValidatePreBill(preBill, false)">
                        <i class="fas fa-undo-alt mr-2"></i>
                        <span>Reversar validación</span>
                      </button>
                      <button mat-menu-item *ngIf="activeState === 'Created'" (click)="onDeletePreBill(preBill)">
                        <i class="fas fa-trash mr-2"></i>
                        <span>Eliminar prefactura</span>
                      </button>
                    </mat-menu>
                  </td>
                </tr>

                <tr *ngIf="isExpanded(preBill)" class="pre-bill-detail-row" (click)="$event.stopPropagation()">
                  <td [attr.colspan]="activeState === 'Created' && prebillRequiresValidation ? 9 : 8">
                    <div class="pre-bill-detail-content">
                      <p *ngIf="isLoadingPreview(preBill)" class="cargos-detail-empty mb-0">
                        Cargando detalle...
                      </p>
                      <ng-container *ngIf="!isLoadingPreview(preBill)">
                        <div *ngIf="hasConfiguredPreview(preBill) && getPreview(preBill) as preview"
                          class="pre-bill-preview">
                          <div class="pre-bill-preview-header">
                            <div class="pre-bill-preview-file">
                              <span class="pre-bill-preview-excel-icon" aria-hidden="true">X</span>
                              <span class="pre-bill-preview-filename">{{ buildPreviewFileName(preBill) + '.xlsx'
                                }}</span>
                              <span class="pre-bill-preview-label">Vista previa</span>
                            </div>
                            <div class="pre-bill-preview-download-wrap" *ngIf="canShowDownloadAction(preBill)">
                              <span class="pre-bill-preview-download-host" matTooltipClass="tooltip__alert">
                                <button type="button" class="pre-bill-preview-download"
                                  (click)="onDownloadPreview(preBill)">
                                  <i class="fas fa-download"></i>
                                  Descargar prefactura
                                </button>
                              </span>
                            </div>
                          </div>

                          <div *ngIf="preview.columns && preview.columns.length" class="pre-bill-preview-grid-wrap">
                            <table class="pre-bill-preview-sheet">
                              <thead>
                                <tr>
                                  <th class="sheet-corner"></th>
                                  <th
                                    *ngFor="let column of preview.columns; let colIndex = index; trackBy: trackByPreviewColumn"
                                    class="sheet-col-letter">{{ getColumnLetter(colIndex) }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="sheet-header-row">
                                  <th class="sheet-row-number">1</th>
                                  <td *ngFor="let column of preview.columns; trackBy: trackByPreviewColumn">
                                    {{ column.name }}
                                  </td>
                                </tr>
                                <tr *ngFor="let row of preview.rows; let rowIndex = index; trackBy: trackByPreviewRow"
                                  class="sheet-data-row" [class.is-clickable]="hasPreviewRowCargo(row)"
                                  matTooltip="Ver servicio" [matTooltipDisabled]="!hasPreviewRowCargo(row)"
                                  (click)="onPreviewRowClick(row)">
                                  <th class="sheet-row-number">{{ rowIndex + 2 }}</th>
                                  <td *ngFor="let column of preview.columns; trackBy: trackByPreviewColumn">
                                    {{ getPreviewCellValue(row, column.id) }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div *ngIf="!hasConfiguredPreview(preBill)" class="pre-bill-fallback">
                          <p *ngIf="shouldShowMissingPreviewAlert(preBill)" class="preview-config-message">
                            <i class="fas fa-exclamation-triangle"></i>
                            <span>Esta prefactura no tiene configurada la previsualización. Se muestra el listado de
                              servicios asociados.</span>
                          </p>
                          <div *ngIf="preBill.cargos && preBill.cargos.length" class="cargos-detail-list">
                            <div *ngFor="let cargo of preBill.cargos; trackBy: trackByCargo" class="cargo-detail-card">
                              <div class="cargo-detail-grid">
                                <div class="cargo-detail-field">
                                  <span class="cargo-detail-label">Servicio</span>
                                  <span class="cargo-detail-value text-bold underline cursor-pointer"
                                    (click)="openCargoDetail(cargo)">{{ cargo.consecutive || '-' }}</span>
                                </div>
                                <div class="cargo-detail-field">
                                  <span class="cargo-detail-label">Origen</span>
                                  <span class="cargo-detail-value">{{ getCargoOrigin(cargo) || '-' }}</span>
                                </div>
                                <div class="cargo-detail-field">
                                  <span class="cargo-detail-label">Destino</span>
                                  <span class="cargo-detail-value">{{ getCargoDestination(cargo) || '-' }}</span>
                                </div>
                                <div class="cargo-detail-field">
                                  <span class="cargo-detail-label">Tarifa</span>
                                  <span class="cargo-detail-value">
                                    {{ getCargoRate(cargo) ? (getCargoRate(cargo) | currency:'COP':'code') : '-' }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <div *ngIf="!paginationList.getList().length" class="container_no_results">
        <div class="icon"><i class="fas fa-file-invoice-dollar"></i></div>
        <h4 class="text-bold text-center">No hay prefacturas en este estado</h4>
      </div>
    </ng-template>
  </div>
</aside>